import PropTypes from 'prop-types';
import React from 'react';

import Image from '../../../components/ContentfulImage';
import Markdown from '../../../components/Markdown';
import Placeholder from '../../../components/Placeholder';
import { Section, SectionInner, ContentWrapper, Title, Text } from './EducationHero.style';

const EducationHero = ({ description, heroImage, title }) => (
  <Section>
    <SectionInner>
      {heroImage ? (
        <Image src={heroImage} options={{ w: ['100%', '100%', '55%'], size: [800] }} />
      ) : (
        <Placeholder w="55%" pb="45%" />
      )}
      <ContentWrapper>
        <Title>{title || <Placeholder h="50px" w="50%" />}</Title>
        {description ? (
          <Markdown src={description} Component={Text} />
        ) : (
          <Text>
            <Placeholder h="100px" w="100%" />
          </Text>
        )}
      </ContentWrapper>
    </SectionInner>
  </Section>
);

EducationHero.defaultProps = {
  description: undefined,
  heroImage: undefined,
  title: undefined,
};

EducationHero.propTypes = {
  description: PropTypes.string,
  heroImage: PropTypes.shape(),
  title: PropTypes.string,
};

export default EducationHero;



// WEBPACK FOOTER //
// ./src/pages/EducationPage/EducationHero/EducationHero.js